import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { ContentBlock, Theme } from '@simplybenefits/sb-ui-library';
import UsageTab from './UsageTab.js';

class Usage extends Component {
    state = {
        value: 0,
        selectedUsage: this.props.usage.user,
        isDependentUsage: false
    };

    _handleChange = (event, value) => {
        this.setState({
            value,
            selectedUsage: Number(value) === 0 ? this.props.usage.user : this.props.usage.dependents[value - 1].usage,
            isDependentUsage: Number(value) !== 0
        });
    };

    render() {
        const { usage, meta } = this.props;
        const styles = {
            tabsRoot: {
                "& .MuiTab-root": {
                    // marginLeft: "-57px"
                }
                
            },
            tabRoot: {
                "&.MuiTab-root": {
                    fontFamily: "AvenirLTPro-Heavy",
                    color: '#000',
                    textTransform: 'capitalize'
                },
                "&.MuiTab-root.Mui-selected": {
                    color: Theme.colors.skyBlue
                }
            }
        };

        const userName = `${ meta.firstname } ${ meta.lastname }`;

        let waivedEHC = false;
        let waivedDental = false;

        if (meta.hasWaived && meta.hasWaived.includes('Health')) {
            waivedEHC = !meta.waiveFor.includes('Self') ?
                (meta.isDependent || this.state.isDependentUsage)
                :
                true;
        }

        if (meta.hasWaived && meta.hasWaived.includes('Dental')) {
            waivedDental = !meta.waiveFor.includes('Self') ?
                (meta.isDependent || this.state.isDependentUsage)
                :
                true;
        }

        if (this.props.isAdjudicationView) {
            return (
                <div style={{ paddingLeft: 50, paddingRight: 50 }}>
                    <Tabs
                        value={this.state.value}
                        indicatorColor="primary"
                        textColor="primary"
                        onChange={this._handleChange}
                        variant="scrollable"
                        scrollButtons={true}
                        sx={{ ...styles.tabsRoot }}
                    >
                        <Tab
                            label="Usage"
                            sx={{ ...styles.tabRoot }}
                        />

                        {
                            !meta.isDependent && usage.dependents.map((dependent) => (
                                <Tab
                                    key={dependent.dependentID}
                                    label={`${ dependent.firstname } ${ dependent.lastname }`}
                                    sx={{ ...styles.tabRoot }}
                                />
                            ))
                        }
                    </Tabs>

                    <UsageTab
                        usage={this.state.selectedUsage}
                        coverage={this.props.coverage}
                        meta={meta}
                        waivedDental={ waivedDental }
                        waivedEHC={ waivedEHC }
                    />
                </div>
            );
        }

        return (
            <div>
                <ContentBlock>
                    <Tabs
                        value={this.state.value}
                        indicatorColor="primary"
                        textColor="primary"
                        onChange={this._handleChange}
                        variant="scrollable"
                        scrollButtons={true}
                        sx={{ ...styles.tabsRoot }}
                    >
                        <Tab
                            label={ userName }
                            sx={{ ...styles.tabRoot }}
                        />

                        {
                            !meta.isDependent && usage.dependents.map((dependent) => (
                                <Tab
                                    key={dependent.dependentID}
                                    label={`${ dependent.firstname } ${ dependent.lastname }`}
                                    sx={{ ...styles.tabRoot }}
                                />
                            ))
                        }
                    </Tabs>

                    <UsageTab
                        usage={this.state.selectedUsage}
                        coverage={this.props.coverage}
                        meta={meta}
                        waivedDental={ waivedDental }
                        waivedEHC={ waivedEHC }
                    />
                </ContentBlock>

                <span id="user-usage" />
            </div>
        );
    }
}

Usage.propTypes = {
    accessType: PropTypes.string
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    accessType: state.master.access
});

export default (connect(mapStateToProps)(Usage));